import { INDUSTRIES } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

export const Industries = () => {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="relative bg-[#FFFFFF] py-24 md:py-40 border-t border-[#C9C3B4]"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20">
          <Reveal>
            <span className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#0055FF]">
              / Industries served
            </span>
            <h2 className="font-display font-800 tracking-tighter text-3xl md:text-5xl lg:text-6xl mt-6 leading-[0.95] max-w-2xl">
              One process. Four markets. Endless parts.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-[#55524B] max-w-xs md:text-right">
              Whatever your sector, if it can be moulded, we can produce it —
              consistently and at volume.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-5">
          {INDUSTRIES.map((ind, i) => (
            <Reveal
              key={ind.key}
              delay={i * 0.06}
              className={`${ind.span} group relative overflow-hidden border border-[#C9C3B4] min-h-[320px] md:min-h-[380px] cursor-pointer`}
            >
              <div
                data-testid={`industry-card-${ind.key}`}
                className="absolute inset-0"
              >
                <img
                  src={ind.img}
                  alt={ind.label}
                  className="h-full w-full object-cover opacity-55 group-hover:opacity-70 group-hover:scale-105 transition-all duration-700 ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A] via-[#0F172A]/50 to-transparent" />
                <div className="absolute inset-0 ring-0 group-hover:ring-1 group-hover:ring-inset group-hover:ring-[#0055FF]/60 transition-all duration-500" />
              </div>

              <div className="relative z-10 h-full p-7 md:p-9 flex flex-col justify-between">
                <div className="flex items-center justify-between">
                  <span className="font-mono-tech text-[10px] uppercase tracking-widest px-2.5 py-1 border border-[#0055FF]/50 text-[#0055FF] bg-[#F5F1EA]/40 backdrop-blur-sm">
                    {ind.tag}
                  </span>
                  <ArrowUpRight className="h-5 w-5 text-white/40 group-hover:text-[#0055FF] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-500" />
                </div>
                <div>
                  <h3 className="font-display font-700 text-2xl md:text-3xl tracking-tight text-white">
                    {ind.label}
                  </h3>
                  <p className="text-[#55524B] mt-2 max-w-sm text-sm md:text-base">
                    {ind.desc}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
